import { atom } from "recoil";

export const focusCCTVUrlState = atom({
  key: "focusCCTVUrlState",
  default: "",
});
